import { render, staticRenderFns } from "./saved_quotes_section.vue?vue&type=template&id=9af73288&"
import script from "./saved_quotes_section.vue?vue&type=script&lang=js&"
export * from "./saved_quotes_section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports